(function () {
  'use strict';
  angular.module('userProfile')
    .component('userHistoryCard', {
        bindings: {
          cardInfo: '=',
          history: '=',
          running: '=',
          onClick: '&'
        },
        controllerAs: 'vm',
        controller: function($log, $filter) {
          var vm = this;
          this.$onInit = function() {
            vm.history = vm.history ? vm.history : [];
          };
          vm.applyFilter = function(field,_filter) {
            if (_filter) {
                return typeof(_filter) === 'function' ? _filter(field) : $filter(_filter)(field);
            }
            return field;
          };
          vm.tooltipText = function(field, _toolTip) {
            if (_toolTip) {
              return _toolTip(field);
            }
            return field;
          };
          vm.navigate = function(history) {
            vm.onClick({event: history});
          };
        },
        templateUrl: '/js/userProfile/userHistoryCard.html' + appVersion
      }
    );
})();
